module.exports = __webpack_public_path__ + "img/imgXharra-1.abb65130.png";